import { Component, Input } from '@angular/core';
import { Contact } from '../../../domain/models/contact';

@Component({
    selector: 'cdp-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent {
    private _contact: Contact;

    @Input()
    get contact(): Contact {
        return this._contact;
    }
    set contact(value: Contact) {
        this._contact = value;
        this.isHCAT = value?.source === 'HCAT' || value?.source === 'Health Catalyst';
        this.shortContactDescription = value?.name || 'Unknown';
        this.shortContactDescription += value?.title ? `, ${value.title}` : '';
        this.shortContactDescription += value?.source ? ` (${value.source})` : '';
    }

    isHCAT = false;
    shortContactDescription = '';
    @Input() exampleThemeColor?: string;
    @Input() themeColor: string;
}
